export default "__VITE_ASSET__CgsYDZQi__"